import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "../../components/accomodation/hero/Hero";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Promise from "../../components/accomodation/promise/Promise";
import Faq from "../../components/accomodation/faq/Faq";
import { IMAGES } from "../../data/images";
import promise1 from "../../assets/images/promise1.webp";
import promise2 from "../../assets/images/promise2.webp";
import promise3 from "../../assets/images/promise3.webp";
import { FAQS } from "../../data/faqs";

const promises = [
  {
    image: promise1,
    title: "Student Fares",
    description:
      "Exclusive discounted fares with extra baggage allowance for international students.",
  },
  {
    image: promise2,
    title: "24/7 Travel Support",
    description:
      "Ever Sky stays in touch before, during, and after your journey for a hassle-free experience.",
  },
  {
    image: promise3,
    title: "Best Price Guarantee",
    description:
      "We compare airlines to find you the most competitive rates for your route.",
  },
];

function Air() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero
        heading="Air Tickets"
        description="Get the best deals on your flights to the USA, Canada, UK, Australia, New Zealand & Germany."
        img={IMAGES.airTickets}
      />
      <Promise
        heading="Our Flight Booking Services"
        description="Whether travel restrictions apply or not, Ever Sky's ticketing service ensures your journey to your dream destination is safe, timely, and hassle-free. All you need to do is get in touch with us."
        promises={promises}
      />
      <section className="layout-band bg-slate-100">
        <div className="layout-container layout-section text-center">
          <h1 id="heading-large">
            Comprehensive travel services at competitive and reliable rates.
          </h1>
          <p id="dark" className="my-4">
            Work with us and enjoy a hassle-free travel experience!
          </p>
          <button
            type="button"
            onClick={() => navigate("/pricing")}
            className="btn-primary"
          >
            Book Flights — ₹999 service fee
          </button>
        </div>
      </section>
      <Faq data={FAQS.air} />
      <Footer />
    </>
  );
}

export default Air;
